import {
	CREATE_RESERVATION_BEGIN,
	CREATE_RESERVATION_SUCCESS,
	CREATE_RESERVATION_ERROR,
} from '../actions/createReservation'

import {
	MODIFY_POST_ENHANCEMENTS_BEGIN,
	MODIFY_POST_ENHANCEMENTS_SUCCESS,
	MODIFY_POST_ENHANCEMENTS_ERROR,
} from '../actions/modifyPostEnhancementsActions'

import {
	MODIFY_PRE_CHECK_IN_BEGIN,
	MODIFY_PRE_CHECK_IN_SUCCESS,
	MODIFY_PRE_CHECK_IN_ERROR,
} from '../actions/modifyPreCheckInActions'

import merge from 'lodash/merge'

const initialState = {
	confirmation: [],
	loading: false,
	error: null,
}

export default function createReservationReducer(state = initialState, action) {
	switch(action.type) {
		case CREATE_RESERVATION_BEGIN:
		case MODIFY_POST_ENHANCEMENTS_BEGIN:
		case MODIFY_PRE_CHECK_IN_BEGIN:
			// Reservation begin: set loading true
			return {
				...state,
				loading: true,
				error: null
			}

		case CREATE_RESERVATION_SUCCESS:
		case MODIFY_POST_ENHANCEMENTS_SUCCESS:
		case MODIFY_PRE_CHECK_IN_SUCCESS:
			// Reservation success: set loading false, and dispatch confirmation data
			return {
				...state,
				loading: false,
				confirmation: merge({}, state.confirmation, action.payload)
			}

		case CREATE_RESERVATION_ERROR:
		case MODIFY_POST_ENHANCEMENTS_ERROR:
			// Reservation failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				confirmation: [],
			}

		case MODIFY_PRE_CHECK_IN_ERROR:
			// Reservation failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
			}

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/createReservationReducers.js